import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ModalReconfirmNumberService {

    public readonly modalState$: Subject<boolean>;

    constructor() {
        this.modalState$ = new Subject<boolean>();
    }

    public open() {
        this.modalState$.next(true);
    }

    public close() {
        this.modalState$.next(false);
    }
}
